<template>
    <div v-if="ready">
        <p>I'm part of a:</p>
        <v-radio-group v-model="profile.type" :mandatory="false">
            <v-radio label="School or District" value="school"></v-radio>
            <v-radio label="Organization" value="organization"></v-radio>
        </v-radio-group>

        <div v-if="profile.type">
            <v-text-field v-if="profile.type == 'school'" label="School or District Name" v-model="profile.organization"></v-text-field>
            <v-text-field  v-if="profile.type == 'organization'" label="Organization" v-model="profile.organization"></v-text-field>
            <v-text-field label="Role" v-model="profile.role"></v-text-field>
            <v-text-field v-if="profile.type == 'school'" label="Grade Level" v-model="profile.grade_level"></v-text-field>
            <v-text-field v-if="profile.type == 'school'" label="Subject" v-model="profile.subject"></v-text-field>
            <v-textarea label="Bio" hint="What would you like other users to know about you?" v-model="profile.bio"></v-textarea>
        </div>

    </div>
</template>

<script>
export default {
  props: [
    'profile'
  ],
  data() {
    return {
      ready: false
    };
  },
  watch: {
    profile: function(val) {
      this.ready = true;
    }
  }
};
</script>
